export default "__VITE_ASSET__CL_3QPMb__"